import { scopedCreator } from 'ha/myredux/createAction';
import { ACTIONS_PREFIX } from '../constants';

const createAction = scopedCreator(ACTIONS_PREFIX);

export const favor = createAction.request('favor');

export default (conversationID, flagStarred) => (dispatch, _, { apiV2 }) =>
  apiV2
    .toggleFavoriteConversation(conversationID, flagStarred)
    .then(() => dispatch(favor.done({ conversationID, flagStarred })))
    .catch(error => dispatch(favor.error(error)));
